var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("div", { staticClass: "box" }, [
        _c("h1", { staticClass: "title is-5" }, [_vm._v("Datos básicos")]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Nombre")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.nombre,
                  expression: "model.nombre",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{required:true}",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.errors.has("nombre", "serie") },
              attrs: { name: "nombre", "data-vv-scope": "serie" },
              domProps: { value: _vm.model.nombre },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "nombre", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.has("nombre", "serie")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("nombre", "serie"))),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Descripcion")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.descripcion,
                  expression: "model.descripcion",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{required:true}",
                },
              ],
              staticClass: "textarea",
              class: { "is-danger": _vm.errors.has("descripcion", "serie") },
              attrs: {
                name: "descripcion",
                "data-vv-scope": "serie",
                rows: "2",
              },
              domProps: { value: _vm.model.descripcion },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "descripcion", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.has("descripcion", "serie")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("descripcion", "serie"))),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.$store.getters.hasAnyRole(["aspec-admin", "lyris"])
        ? _c("div", { staticClass: "box" }, [
            _c(
              "span",
              { staticClass: "tag is-primary is-pulled-right" },
              [
                _vm._v("Módulo activado "),
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      type: "is-primary is-light",
                      label: "Disponible por contar con el módulo activado",
                    },
                  },
                  [_c("i", { staticClass: "fas fa-question-circle" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("h1", { staticClass: "title is-5" }, [
              _vm._v("Aspectos iniciales"),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  _vm._l(_vm.aspectos, function (aspecto) {
                    return _c(
                      "b-checkbox",
                      {
                        key: aspecto.id,
                        attrs: { "native-value": aspecto },
                        model: {
                          value: _vm.model.aspectosSeleccionados,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "aspectosSeleccionados", $$v)
                          },
                          expression: "model.aspectosSeleccionados",
                        },
                      },
                      [_vm._v(_vm._s(aspecto.nombre))]
                    )
                  }),
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("h1", { staticClass: "title is-4" }, [_vm._v("Estados")]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field is-grouped" }, [
            _c("div", { staticClass: "control is-expanded" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.estado.nombre,
                    expression: "input.estado.nombre",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{required: true}",
                  },
                ],
                staticClass: "input",
                class: {
                  "is-danger": _vm.errors.has("Nombre del estado", "estado"),
                },
                attrs: {
                  name: "Nombre del estado",
                  "data-vv-scope": "estado",
                  placeholder: "Ingrese el nombre de un estado",
                },
                domProps: { value: _vm.input.estado.nombre },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.agregarEstado.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.input.estado, "nombre", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help" }, [
                _vm._v("Nombre del estado"),
              ]),
              _vm._v(" "),
              _vm.errors.has("Nombre del estado", "estado")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first("Nombre del estado", "estado"))
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control is-expanded" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.estado.slug,
                    expression: "input.estado.slug",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      regex: /^[a-z0-9]+(?:[-_+][a-z0-9]+)*$/,
                    },
                    expression:
                      "{required: true, regex: /^[a-z0-9]+(?:[-_+][a-z0-9]+)*$/ }",
                  },
                ],
                staticClass: "input",
                class: {
                  "is-danger": _vm.errors.has("Clave del estado", "estado"),
                },
                attrs: { name: "Clave del estado", "data-vv-scope": "estado" },
                domProps: { value: _vm.input.estado.slug },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.agregarEstado.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.input.estado, "slug", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help" }, [
                _vm._v(
                  "La clave del estado es autogenerado pero pude editarlo de preferirlo"
                ),
              ]),
              _vm._v(" "),
              _vm.errors.has("Clave del estado", "estado")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(
                      _vm._s(_vm.errors.first("Clave del estado", "estado"))
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "control", on: { click: _vm.agregarEstado } },
              [_vm._m(2)]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Listad de estados")]),
          _vm._v(" "),
          _vm.estados.length == 0
            ? _c("p", [_vm._v("No se han ingresado estados de la serie")])
            : _c(
                "div",
                { staticClass: "tags" },
                _vm._l(_vm.estados, function (estado, index) {
                  return _c(
                    "p",
                    { key: index, staticClass: "tag is-info is-medium" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(estado.nombre) +
                          "\n            "
                      ),
                      _c("button", {
                        staticClass: "delete is-small",
                        on: {
                          click: function ($event) {
                            return _vm.eliminarEstado(estado.slug)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Estado inicial")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "select is-fullwidth" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model.estado_inicial,
                      expression: "model.estado_inicial",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true },
                      expression: "{required:true}",
                    },
                  ],
                  class: {
                    "is-danger": _vm.errors.has("Estado inicial", "serie"),
                  },
                  attrs: { name: "Estado inicial", "data-vv-scope": "serie" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.model,
                        "estado_inicial",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("- Seleccione un estado inicial -")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.estados, function (estado, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: estado.slug } },
                      [_vm._v(_vm._s(estado.nombre))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.errors.has("Estado inicial", "serie")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("Estado inicial", "serie"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("h1", { staticClass: "title is-5" }, [
          _vm._v("Subunidades del documento"),
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Nombre y clave")]),
          _vm._v(" "),
          _c("div", { staticClass: "field is-grouped" }, [
            _c("div", { staticClass: "control is-expanded" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.subdocumento.nombre,
                    expression: "input.subdocumento.nombre",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{required:true}",
                  },
                ],
                staticClass: "input",
                class: {
                  "is-danger": _vm.errors.has(
                    "Nombre del sub-documento",
                    "subdoc"
                  ),
                },
                attrs: {
                  name: "Nombre del sub-documento",
                  "data-vv-scope": "subdoc",
                },
                domProps: { value: _vm.input.subdocumento.nombre },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.input.subdocumento,
                      "nombre",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.has("Nombre del sub-documento", "subdoc")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(
                      _vm._s(
                        _vm.errors.first("Nombre del sub-documento", "subdoc")
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control is-expanded" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input.subdocumento.key,
                    expression: "input.subdocumento.key",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      regex: /^[a-z0-9]+(?:[-_+][a-z0-9#]+)*$/,
                    },
                    expression:
                      "{ required: true, regex: /^[a-z0-9]+(?:[-_+][a-z0-9#]+)*$/ }",
                  },
                ],
                staticClass: "input",
                class: {
                  "is-danger": _vm.errors.has(
                    "Clave del sub-documento",
                    "subdoc"
                  ),
                },
                attrs: {
                  name: "Clave del sub-documento",
                  "data-vv-scope": "subdoc",
                },
                domProps: { value: _vm.input.subdocumento.key },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.input.subdocumento, "key", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help" }, [
                _vm._v(
                  "La clave de la subunidad es autogenerado pero pude editarlo de preferirlo"
                ),
              ]),
              _vm._v(" "),
              _vm.errors.has("Clave del sub-documento", "subdoc")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(
                      _vm._s(
                        _vm.errors.first("Clave del sub-documento", "subdoc")
                      )
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Formatos aceptables"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "block" },
                  _vm._l(_vm.formatosDisponibles, function (formato) {
                    return _c(
                      "b-checkbox",
                      {
                        key: formato,
                        attrs: { "native-value": formato, disabled: "" },
                        model: {
                          value: _vm.input.subdocumento.formatosSeleccionados,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.input.subdocumento,
                              "formatosSeleccionados",
                              $$v
                            )
                          },
                          expression:
                            "input.subdocumento.formatosSeleccionados",
                        },
                      },
                      [_vm._v(_vm._s(formato))]
                    )
                  }),
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("¿Es colección de documentos?"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c(
                      "b-radio",
                      {
                        attrs: { "native-value": true },
                        model: {
                          value: _vm.input.subdocumento.multiple,
                          callback: function ($$v) {
                            _vm.$set(_vm.input.subdocumento, "multiple", $$v)
                          },
                          expression: "input.subdocumento.multiple",
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-check" }),
                        _vm._v(" Si\n                "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-radio",
                      {
                        attrs: { "native-value": false },
                        model: {
                          value: _vm.input.subdocumento.multiple,
                          callback: function ($$v) {
                            _vm.$set(_vm.input.subdocumento, "multiple", $$v)
                          },
                          expression: "input.subdocumento.multiple",
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-times" }),
                        _vm._v(" No\n                "),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column is-narrow" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  on: { click: _vm.addSubdocumento },
                },
                [
                  _c("i", { staticClass: "fas fa-plus" }),
                  _vm._v(" Agregar\n            "),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Subunidades agregadas"),
        ]),
        _vm._v(" "),
        _vm.subdocumentos.length > 0
          ? _c(
              "div",
              { staticClass: "columns is-multiline" },
              _vm._l(_vm.subdocumentos, function (subdoc) {
                return _c(
                  "div",
                  {
                    key: `doc-${subdoc.key}`,
                    staticClass: "column is-6 is-4-desktop",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "box p-3 is-flex is-flex-direction-row" },
                      [
                        _c("div", { staticClass: "mr-4" }, [
                          _c("i", {
                            staticClass: "far fa-2x has-text-primary",
                            class: {
                              "fa-copy": subdoc.multiple,
                              "fa-file": !subdoc.multiple,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-flex-grow-1" }, [
                          _c("h4", { staticClass: "title is-6" }, [
                            _vm._v(_vm._s(subdoc.nombre)),
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "subtitle is-7 mb-3" }, [
                            _vm._v(_vm._s(subdoc.key)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-7" }, [
                            _c("p", [
                              _c("b", [_vm._v("Formatos")]),
                              _vm._v(
                                ": " +
                                  _vm._s(
                                    subdoc.formatosSeleccionados.join(", ")
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c("b", [_vm._v("¿Colección?")]),
                              _vm._v(" \n               "),
                              _c("i", {
                                staticClass: "fas",
                                class: {
                                  "fa-check": subdoc.multiple,
                                  "fa-times": !subdoc.multiple,
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(subdoc.multiple ? "Si" : "No") +
                                  "\n              "
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ml-4" }, [
                          _c("p", [
                            _c(
                              "a",
                              {
                                staticClass: "has-text-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.eliminarSubdocumento(subdoc.key)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fas fa-times-circle" })]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _c("p", { staticClass: "mt-5 is-italic is-mono" }, [
              _vm._v("\n        - No hay eventos en la serie -\n      "),
            ]),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("b-message", { attrs: { type: "is-link" } }, [
        _c("h5", { staticClass: "title is-5 has-text-link is-marginless" }, [
          _c("i", { staticClass: "fas fa-info-circle" }),
          _vm._v(" Información importante"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Esta serie se creará sin eventos. Podra cargarlos luego de haber creado la serie documental. Presione "
          ),
          _c("i", { staticClass: "fas fa-save fa-fw" }),
          _vm._v(" "),
          _c("b", [_vm._v("Crear serie")]),
          _vm._v(" para ir a la pantalla y continuar con la carga de datos"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "has-text-centered" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary is-medium",
            on: { click: _vm.submit },
          },
          [
            _c("i", { staticClass: "fas fa-save fa-fw" }),
            _vm._v(" Crear serie\n  "),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Elija que aspectos de documentos quiere definir para la serie."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Agregue los estados de la serie completando los campos y haciendo clic en "
        ),
        _c("span", { staticClass: "has-text-primary" }, [
          _c("i", { staticClass: "fas fa-plus" }),
          _vm._v(" Agregar"),
        ]),
        _vm._v(". Puede eliminar haciendo clic en el botón "),
        _c("i", { staticClass: "fas fa-times-circle has-text-primary" }),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Recuerde seleccionar un estado inicial para la serie")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("button", { staticClass: "button is-primary" }, [
      _c("i", { staticClass: "fas fa-plus" }),
      _vm._v(" Agregar\n            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Agregué a la serie documental nuevas subunidades. Complete los campos y haga clic en "
        ),
        _c("span", { staticClass: "has-text-primary" }, [
          _c("i", { staticClass: "fas fa-plus" }),
          _vm._v(" Agregar"),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("NOTA:")]),
        _vm._v(
          " Preferiblemente utilice un nombre y/o una clave no utilizada en las subunidades ya instanciadas"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }